import { useMemo } from 'react';

import { MessagingPlatform, UserCommunication } from '@this+that/models';

export const useHasOutlookEmails = (
  communications: UserCommunication[],
  selectedItems: Set<string>,
): { hasOutlookEmails: boolean } => {
  const hasOutlookEmails = useMemo(() => {
    const selectedCommunications = communications.filter((comm) =>
      selectedItems.has(comm.messageId),
    );

    if (selectedCommunications.length === 0) {
      return false;
    }

    return selectedCommunications.some(
      (comm) => comm.platform === MessagingPlatform.OUTLOOK,
    );
  }, [communications, selectedItems]);

  return { hasOutlookEmails };
};
